"use client";

import React from "react";
import dynamic from "next/dynamic";

// Client-side only ShareThis component
const ShareThisComponent = dynamic(
  () => import("../ShareThis/ShareThis"),
  { 
    ssr: false,
    loading: () => <div>Loading sharing options...</div>
  }
);

export default ShareThisComponent;